var _g, _path, _rect, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3445_13608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.32 120.5C104.163 120.5 102.414 118.751 102.414 116.594C102.414 101.301 89.9725 88.8594 74.6797 88.8594H68.8203C53.5275 88.8594 41.0859 101.301 41.0859 116.594C41.0859 118.751 39.3371 120.5 37.1797 120.5C35.0223 120.5 33.2734 118.751 33.2734 116.594C33.2734 96.9932 49.2197 81.0469 68.8203 81.0469H74.6797C94.2803 81.0469 110.227 96.9932 110.227 116.594C110.227 118.751 108.478 120.5 106.32 120.5Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3594 73.2344C56.8205 73.2344 44.9922 61.4061 44.9922 46.8672C44.9922 32.3283 56.8205 20.5 71.3594 20.5C85.8982 20.5 97.7266 32.3283 97.7266 46.8672C97.7266 61.4061 85.8982 73.2344 71.3594 73.2344ZM71.3594 28.3125C61.1283 28.3125 52.8047 36.6361 52.8047 46.8672C52.8047 57.0982 61.1283 65.4219 71.3594 65.4219C81.5904 65.4219 89.9141 57.0982 89.9141 46.8672C89.9141 36.6361 81.5904 28.3125 71.3594 28.3125Z",
    fill: "#7663EB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.5 70.5C126.5 101.428 101.428 126.5 70.5 126.5C57.5668 126.5 45.6576 122.116 36.1776 114.752L114.752 36.1776C122.116 45.6576 126.5 57.5668 126.5 70.5ZM26.2743 104.857L104.857 26.2743C95.371 18.8948 83.4488 14.5 70.5 14.5C39.5721 14.5 14.5 39.5721 14.5 70.5C14.5 83.4488 18.8948 95.371 26.2743 104.857ZM140.5 70.5C140.5 109.16 109.16 140.5 70.5 140.5C31.8401 140.5 0.5 109.16 0.5 70.5C0.5 31.8401 31.8401 0.5 70.5 0.5C109.16 0.5 140.5 31.8401 140.5 70.5Z",
    fill: "#495057"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.25,
    y: 90.5,
    width: 25,
    height: 25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.25 84.25C94.8125 84.25 83 96.0625 83 110.5C83 124.938 94.8125 136.75 109.25 136.75C123.688 136.75 135.5 124.938 135.5 110.5C135.5 96.0625 123.688 84.25 109.25 84.25ZM122.375 112.375H109.25C108.125 112.375 107.375 111.625 107.375 110.5V93.625C107.375 92.5 108.125 91.75 109.25 91.75C110.375 91.75 111.125 92.5 111.125 93.625V108.625H122.375C123.5 108.625 124.25 109.375 124.25 110.5C124.25 111.625 123.5 112.375 122.375 112.375Z",
    fill: "#FF4800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3445_13608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(21.75 20.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendUser);
export default __webpack_public_path__ + "static/media/suspend-user.5b7d208f46f5bb99f92f391199775211.svg";
export { ForwardRef as ReactComponent };